import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import CustomAccordion from "../../common/CustomAccordion";
import DrawerComponent from "../../common/DrawerComponent";
import { useScreenWidth } from "../hooks";
import styles from "./styles.module.scss";
const NutritionFactsDrawer = ({ openDrawer, toggleDrawer, nutritionFacts }) => {
    const isMobile = useScreenWidth() < 968;
    return (_jsxs(DrawerComponent, { crossButton: true, open: openDrawer, toggleDrawer: toggleDrawer, anchor: isMobile ? "bottom" : "right", extraClassName: styles.flavors_select_drawer, children: [_jsx("h2", { className: styles.title, children: "Nutrition Facts" }), _jsx("div", { className: styles.nutrition_facts, children: nutritionFacts.map((item) => (_jsx(CustomAccordion, { extraClassName: styles.nutrition_accordeon, title: item.title, children: _jsx("img", { src: item.img, style: { maxWidth: "100%", margin: "0 auto" }, alt: "" }) }, item.title))) })] }));
};
export default NutritionFactsDrawer;
